
export default function Footer() {
  const navigateToPage = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="text-2xl font-light mb-4 tracking-wide" style={{ fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif', color: '#7E887E', letterSpacing: '0.5px' }}>
              Lavin Enterprises & Co.
            </div>
            <p className="text-gray-400 mb-6">
              Leading provider of advanced construction chemicals and protective solutions for modern infrastructure projects worldwide.
            </p>
            <div className="flex space-x-4">
              <a 
                href="#" 
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                style={{ backgroundColor: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#6B756B'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#7E887E'}
              >
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                style={{ backgroundColor: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#6B756B'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#7E887E'}
              >
                <i className="ri-twitter-fill text-white"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                style={{ backgroundColor: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#6B756B'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#7E887E'}
              >
                <i className="ri-linkedin-fill text-white"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                style={{ backgroundColor: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#6B756B'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#7E887E'}
              >
                <i className="ri-instagram-fill text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => navigateToPage('/')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigateToPage('/about')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigateToPage('/services')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigateToPage('/products')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Products
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigateToPage('/industries')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Industries
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Products</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Waterproofing</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Concrete Repair</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Protective Coatings</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Structural Adhesives</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Flooring Systems</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-4">
              <div>
                <div className="flex items-start mb-2">
                  <i className="ri-map-pin-line text-gray-400 mr-3 mt-1"></i>
                  <div>
                    <p className="text-gray-300 font-medium mb-1">Head Office:</p>
                    <p className="text-gray-400">
                      Plot No- 179, Subhash Enclave<br />
                      Sector - 72a, Tikri, Gurgaon - 122001<br />
                      Haryana
                    </p>
                  </div>
                </div>
                <div className="flex items-start ml-6">
                  <div>
                    <p className="text-gray-300 font-medium mb-1">Branch Office:</p>
                    <p className="text-gray-400">
                      Rain Boosting Station, NEAR KORIYAWAS MOOD<br />
                      Nizampur Road, Narnaul Mahendragarh<br />
                      Haryana, 123001
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-gray-400 mr-3"></i>
                <p className="text-gray-400">+91 8130956009</p>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-gray-400 mr-3"></i>
                <p className="text-gray-400">+91 9467112024</p>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-gray-400 mr-3"></i>
                <p className="text-gray-400">info@lavinenterprises.com</p>
              </div>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Lavin Enterprises & Co. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <button 
                onClick={() => navigateToPage('/privacy')}
                className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => navigateToPage('/terms')}
                className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Terms of Service
              </button>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
